import React from 'react';
import { StyledHalfColTextFlex } from './StyledHalfColTextFlex';

const HalfColTextFlex = ({ children }) => {
  return (
    <React.Fragment>
      {
        <StyledHalfColTextFlex>
          {children}
        </StyledHalfColTextFlex>
      }
    </React.Fragment>
  );
};


export default HalfColTextFlex;
